module.exports = __webpack_public_path__ + "89df36bab9bb9672dd1c8f02c737ab11.svg";